// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner-auth-access_wrapper__zrAn1","title":"banner-auth-access_title__NPsAL","txt":"banner-auth-access_txt__6llwO"};